<template>
  <div class="responsible">
    <div v-if="worker" class="wrapper">
      <userpic class="icon" :url="worker.photo" />
      <div class="data">
        <router-link
          class="name"
          target="_blank"
          :to="{
            name: 'personal-employee-summary',
            params: { id: worker.id },
          }"
        >
          {{ worker.name }}
        </router-link>
        <div class="label">Ответственный</div>
      </div>
    </div>
    <div v-else class="wrapper">
      <div class="icon">
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="17" cy="17" r="17" fill="#BFC9E0" />
          <path
            d="M12 14C12 13.0111 12.2932 12.0444 12.8427 11.2222C13.3921 10.3999 14.173 9.75904 15.0866 9.3806C16.0002 9.00217 17.0055 8.90315 17.9755 9.09608C18.9454 9.289 19.8363 9.76521 20.5355 10.4645C21.2348 11.1637 21.711 12.0546 21.9039 13.0246C22.0969 13.9945 21.9978 14.9998 21.6194 15.9134C21.241 16.8271 20.6001 17.6079 19.7779 18.1574C19.4501 18.3763 19.007 18.5103 18.7335 18.6899C17.5 19.5 17 20 17 22"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle cx="17" cy="26" r="1" fill="white" />
        </svg>
      </div>
      <div class="data">
        <div class="label">Ответственного нет</div>
        <div class="assign" @click="$emit('assign')">Назначить</div>
      </div>
    </div>
  </div>
</template>

<script>
import Userpic from "@/components/user/userpic";

export default {
  components: { Userpic },
  props: ["worker"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.responsible {
  .wrapper {
    display: flex;
    align-items: center;
  }
  .data {
    line-height: 1.3;
  }
  .icon {
    margin-right: 10px;
  }
  .label {
    color: $color-label;
    font-size: 12px;
  }
  .name {
    font-size: 13px;
  }
  .assign {
    color: $color-primary;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
